import React from 'react';
import { GiCardboardBoxClosed } from "react-icons/gi";
import { GiClick } from "react-icons/gi";
import { mainImage } from '../../../assist/images/index';

const RightContent = () => {

    const designs = [
        { name: 'Vinyl ', color: 'bg-stone-900' },
        { name: 'Wood ', color: 'bg-stone-700' },

    ];

    const colours = [
        { name: 'Gray', color: 'bg-slate-800' },
        { name: 'Black', color: 'bg-black' }
    ]
    
  return (
    <div className="w-full lg:w-2/3">
        {/*Right content upper part*/}
        <div className="xs:border-b-0 " >
            <div className="flex flex-col lg:flex-row gap-5 justify-between items-center p-1 lg:border-b-2 lg:border-b-slate-800">
                <div className="xs:w-full xs:flex xs:flex-col xs:gap-5 lg:flex lg:flex-row lg:w-auto font-bold gap-10 p-2 items-center">
                    <div className="xs:ml-0 lg:justify-center lg:items-center w-auto mx-auto whitespace-nowrap">
                        <h2>Styles Currently Active:</h2>
                    </div>
                    <div className="flex flex-col w-full lg:w-auto">
                        <div class="xs:flex xs:flex-wrap sml:flex-nowrap gap-2 lg:flex flex-row lg:justify-around">
                            {designs.map((design, index) => (
                                <div key={index} className="flex flex-col items-center gap-2">
                                    <div className={`size-10 rounded-xl shadow-lg cursor-pointer ${design.color}`}>
                                    </div>
                                    <div className="badge badge-neutral text-textWhiteColor p-2 rounded-xl text-xs text-center">
                                        {design.name}
                                    </div>
                                </div>
                            ))}
                            {colours.map((colour, index) => (
                                <div key={index} className="flex flex-col items-center gap-2">
                                    <div className={`size-10 rounded-xl shadow-lg cursor-pointer ${colour.color}`}>
                                    </div>
                                    <div className="badge badge-neutral text-textWhiteColor p-2 rounded-xl text-xs text-center">
                                        {colour.name}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="w-full xs:flex xs:justify-start lg:justify-end lg:mt-0">
                    <button 
                        className="text-red-600 p-5 py-1 text-sm font-bold" 
                    >
                        Reset Design
                    </button>
                </div>
            </div> 
        </div> 
        <div>
        <div className="xs:mt-0 p-5 flex justify-center items-center min-h-[700px] max-h-[80vh] lg:mt-0">
            <img src={mainImage} alt="Main House" className="w-[700px] h-auto object-cover"/>
        </div>
        <div className="absolute bottom-5 right-5 p-2">
            <div className="flex flex-col items-end"> 
                <div className="flex space-x-2 mb-2 gap-5">
                <div className="flex items-center space-x-2 cursor-grab">
                    <GiCardboardBoxClosed size={50} />
                </div>
                    <GiClick size={50} />
                </div>
                <p className="text-md max-w-[400px] text-right font-bold">
                    Use arrows or mouse to explore different views.
                    Click and drag icon or mouse to rotate the model.
                </p>
            </div>
        </div>
        </div>    
    </div>
  )
}

export default RightContent;